module.exports = __webpack_public_path__ + "img/mark_error.a3144f99.png";